// 导入所有 affiliate 模块的国际化文件
import { messages as affiliateWithdrawalMessages } from '@/lang/affiliate/affiliateWithdrawalLang.js'
import { messages as affiliateMessages } from '@/lang/affiliate/affiliateLang.js'
import { messages as affiliateUserMessages } from '@/lang/affiliate/affiliateUserLang.js'
import { messages as affiliateRuleMessages } from '@/lang/affiliate/affiliateRuleLang.js'
import { messages as affiliateRelationMessages } from '@/lang/affiliate/affiliateRelationLang.js'
import { messages as affiliateProductMessages } from '@/lang/affiliate/affiliateProductLang.js'
import { messages as affiliateCommissionMessages } from '@/lang/affiliate/affiliateCommissionLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...affiliateWithdrawalMessages.en,
        ...affiliateMessages.en,
        ...affiliateUserMessages.en,
        ...affiliateRuleMessages.en,
        ...affiliateRelationMessages.en,
        ...affiliateProductMessages.en,
        ...affiliateCommissionMessages.en
    },
    zh: {
        ...affiliateWithdrawalMessages.zh,
        ...affiliateMessages.zh,
        ...affiliateUserMessages.zh,
        ...affiliateRuleMessages.zh,
        ...affiliateRelationMessages.zh,
        ...affiliateProductMessages.zh,
        ...affiliateCommissionMessages.zh
    }
}
